import React, { useContext } from 'react';
import UserContext from '../../context/UserContext';
import Login from '../../pages/Login';

export default function LoginWrapper({ children }) {
  const { isAuthorized } = useContext(UserContext);

  return isAuthorized ? children : <Login />;
}
